import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { FlujoVentaPasoVinculacion } from '../_models/flujo-venta-paso-vinculacion';

@Injectable({
  providedIn: 'root'
})
export class FlujoVentaPasoVinculacionService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/flujoVentaPasosVinculaciones';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as FlujoVentaPasoVinculacion[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as FlujoVentaPasoVinculacion[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as FlujoVentaPasoVinculacion ) );
  }

  listadoPorIdFlujoPaso( id: string ) {
    return this.httClient.get( this.rutServicio + '/flujoVenta/' + id ).pipe( map( res => res as FlujoVentaPasoVinculacion[] ) );
  }

  crear( regCrear: FlujoVentaPasoVinculacion ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as FlujoVentaPasoVinculacion ) );
  }

  actualizar( regActualizar: FlujoVentaPasoVinculacion ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as FlujoVentaPasoVinculacion ) );
  }

  bulk( registros: FlujoVentaPasoVinculacion[] ) {
    registros.forEach( e => {
      e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( `${ this.rutServicio }/bulk`, registros ).pipe( map( res => res as FlujoVentaPasoVinculacion[] ) );
  }
}
